import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SparkleIcon } from './icons/index.js';
export function DevBanner() {
    return (_jsxs("div", { className: "sl-dev-banner", role: "alert", children: [_jsx(SparkleIcon, { size: 14 }), _jsx("span", { children: "MODO DEV \u2014 auth em bypass" })] }));
}
//# sourceMappingURL=DevBanner.js.map